// extracted by mini-css-extract-plugin
export default {"cardStack":"CardPage_cardStack__vAY7G"};